import React, {useEffect, useState} from 'react'
import axios from 'axios'
import {
	Link
} from 'react-router-dom';
import Loader from '../../components/Loader';
import axiosInstance from '../../utils/api';

type Props = {}

interface InstallationInterface {
    id: number;
    serial: string;
    date_installation: string;
    condition: string;
    customer: { name : null | string } | null;
    platform_fees: string|null;
    product:string|null;
    pumpa: string|null;
    pumpb: string|null;
    pumpc: string|null;
    simcard: {serial: null | string} | null;
    sensor:any;
    controller: Array<any>;
    updated_by: string|null;
    remark:string|null;
    datetime:string|null;
    app_board:null|[];
    payment_status: string
}


const InstallationListV2 = (props: Props) => {
    const title = "Installation"
    const [installations, setInstallations] = useState<Array<InstallationInterface>>([])
    const [loading, setLoading] = useState(false)
    const [appBoardModalStatus, setAppBoardModalStatus] = useState(false)
    const [appBoardModalData, setappBoardModalData] = useState<any>([])

    useEffect(() => {
        getDataList()
    }, [])

    function getDataList() {
        // setInstallations(defaultData)
        setLoading(true)
        axiosInstance.get("https://api.cloudatik.com/internal/operations/v2.0/installation").then(res=>{
            setLoading(false)
            console.log(res.data)
            setInstallations(res.data)
        }).catch(err=>{
            setLoading(false)
            console.log(123, err)
        })
    }

    function handleDelete(id:string) {
        if (!window.confirm("Are you sure you want to delete record?")) return
        axiosInstance.delete(`https://api.cloudatik.com/internal/operations/v2.0/installation/${id}/`).then(res=>{
            console.log(11, res)
            alert(res.data.message)
            getDataList()
        }).catch(err=>{
            console.log(123, err)
        })
    }

    const [search, setSearch] = useState("")

    const filteredInstallations = installations.filter((installation) =>
        Object.values({
            serial: installation.serial,
            date_installation: installation.date_installation,
            condition: installation.condition,
            customer: installation.customer?.name,
            remark: installation.remark,
            payment_status: installation.payment_status,
        })
        .join(" ")
        .toLowerCase()
        .includes(search.toLowerCase())
    )


    return (
            <div className="col-12">
                {loading && ( <Loader/> )}

                <div className="card">
                    <div className="card-body">
                        <div className="row px-2" style={{display:"grid", gridTemplateColumns:"1fr 1fr"}}>
                            <h5 className="card-title">{title} List</h5>
                            <div style={{display:"flex", justifyContent:"end", alignSelf:"center"}}>
                                
                                <Link to="/installationv2/add" >
                                    <button type="button" className="btn btn-outline-info">Create</button>
                                </Link>
                            </div>
                        </div>
                        <div className="row" style={{justifyContent:"end"}}>
                            <div className="col-3">
                                <input type="text" className="form-control" placeholder="Search" value={search} onChange={(e) => setSearch(e.target.value)}/>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th scope="col">Serial</th>
                                        <th scope="col">Date Installation</th>
                                        <th scope="col">Condition</th>
                                        <th scope="col">Customer</th>
                                        <th scope="col">Payment Status</th>
                                        <th scope="col">App Board Serial</th>
                                        <th scope="col">Remark</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredInstallations.map( (installation, index) => {

                                        return (
                                            <tr key={index}>
                                                <th scope="row">{installation.serial}</th>
                                                <td>{installation.date_installation}</td>
                                                <td>{installation.condition}</td>
                                                <td>{installation.customer ? installation.customer?.name : "-"}</td>
                                                <td>{installation.payment_status ? installation.payment_status : "-" }</td>
                                                <td>{(installation.app_board && installation.app_board.length > 0) ? (
                                                    <>
                                                    <button type="button" className="btn btn-sm btn-primary" onClick={()=>{
                                                        setAppBoardModalStatus(true)
                                                        setappBoardModalData(installation.app_board)
                                                    }}>Show</button>
                                                    </>
                                                ) : (
                                                    <>
                                                    <button type="button" className="btn btn-sm btn-secondary" disabled>Show</button>
                                                    </>
                                                )}</td>
                                                <td>{installation.remark}</td>
                                                <td>
                                                    <div className='d-flex'>
                                                        <Link to={`/installationv2/edit/${installation.id}`}>
                                                            <button type="button" className="btn btn-outline-info me-2">
                                                                <i className="bi bi-pencil"></i>
                                                            </button>
                                                        </Link>
                                                        <div>
                                                            <button type="button" className="btn btn-outline-danger" onClick={() => { handleDelete(installation.id.toString()) }} >
                                                                <i className="bi bi-trash"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    

                    </div>
                </div>



                <div className="modal fade show" style={appBoardModalStatus ? {display:'block'} : {display: 'none'}}>
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLongTitle">App Board List</h5>
                        </div>
                        <div className="modal-body">
                                <>
                                {appBoardModalData.map((app:any) => {
                                    return (
                                        <>
                                        <p>{app.app_board_serial}</p>
                                        <p>{app.remark}</p>
                                        </>
                                    )
                                })}
                                </>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={()=>{
                                setAppBoardModalStatus(false)
                                setappBoardModalData([])
                            }}>Close</button>
                        </div>
                        </div>
                    </div>
                </div>
                
            </div>

    )
}

// const defaultData:Array<InstallationInterface> = [
//     {
//         "id": 1,
//         "product": "Agridose Hydroponics",
//         "pumpa": "43E68322B",
//         "pumpb": "55B",
//         "pumpc": "65B",
//         "simcard": null,
//         "customer": "Yuan Jin",
//         "sensor": [
//             {
//                 "id": "7",
//                 "serial": "LPHT35"
//             },
//             {
//                 "id": "6",
//                 "serial": "LECP40"
//             }
//         ],
//         "controller": [],
//         "updated_by": null,
//         "date_installation": "2022-09-28",
//         "condition": "New Installation",
//         "platform_fees": null,
//         "remark": null,
//         "datetime": "2022-10-16T04:51:55+08:00",
//         "serial": "AM1028"
//     },
//     {
//         "id": 2,
//         "product": "Agridose Hydroponics",
//         "pumpa": "37B",
//         "pumpb": "43E68333B",
//         "pumpc": "67B",
//         "simcard": "896019210291464384",
//         "customer": "Cameron Chai",
//         "sensor": [
//             {
//                 "id": "7",
//                 "serial": "LPHT35"
//             },
//             {
//                 "id": "6",
//                 "serial": "LECP40"
//             }
//         ],
//         "controller": [],
//         "updated_by": "aquametrics",
//         "date_installation": "2022-05-24",
//         "condition": "New Installation",
//         "platform_fees": null,
//         "remark": null,
//         "datetime": "2022-10-16T09:05:53+08:00",
//         "serial": "AM1027"
//     },
//     {
//         "id": 3,
//         "product": "Agridose Hydroponics",
//         "pumpa": "24E93883B",
//         "pumpb": "24E93895B",
//         "pumpc": "24E95105B",
//         "simcard": "896019200694401149",
//         "customer": "SFN",
//         "sensor": [
//             {
//                 "id": "11",
//                 "serial": "LECP12"
//             }
//         ],
//         "controller": [
//             {
//                 "id": "2",
//                 "board_name": "Agridose Application Board",
//                 "mcuid": "THOR1"
//             },
//             {
//                 "id": "5",
//                 "board_name": "HaHa Davis Weather Station",
//                 "mcuid": "b03270fa48a8"
//             }
//         ],
//         "updated_by": "aquametrics",
//         "date_installation": "2021-10-21",
//         "condition": "New Installation",
//         "platform_fees": "150",
//         "remark": null,
//         "datetime": "2022-10-18T11:02:47+08:00",
//         "serial": "AM1008"
//     },
//     {
//         "id": 4,
//         "product": "Agridose Application Board",
//         "pumpa": "26E02446B",
//         "pumpb": "23E88842B",
//         "pumpc": "23E89460B",
//         "simcard": "896019200694297256",
//         "customer": "Chang test",
//         "sensor": [
//             {
//                 "id": "23",
//                 "serial": "LPHT03"
//             },
//             {
//                 "id": "24",
//                 "serial": "LECP07"
//             }
//         ],
//         "controller": [],
//         "updated_by": null,
//         "date_installation": "2021-09-14",
//         "condition": "New Installation",
//         "platform_fees": "200",
//         "remark": null,
//         "datetime": "2022-10-18T12:28:51+08:00",
//         "serial": "AM1006"
//     },
//     {
//         "id": 5,
//         "product": "Agridose Hydroponics",
//         "pumpa": null,
//         "pumpb": null,
//         "pumpc": null,
//         "simcard": null,
//         "customer": "SFN",
//         "sensor": [
//             {
//                 "id": "26",
//                 "serial": "LPHT10"
//             },
//             {
//                 "id": "25",
//                 "serial": "LECP08"
//             }
//         ],
//         "controller": [],
//         "updated_by": null,
//         "date_installation": "2021-09-25",
//         "condition": "New Installation",
//         "platform_fees": "150",
//         "remark": null,
//         "datetime": "2022-10-18T12:38:40+08:00",
//         "serial": "AM1007"
//     },
//     {
//         "id": 6,
//         "product": "Agridose Hydroponics",
//         "pumpa": null,
//         "pumpb": null,
//         "pumpc": null,
//         "simcard": null,
//         "customer": "SFN",
//         "sensor": [
//             {
//                 "id": "27",
//                 "serial": "LECP35"
//             }
//         ],
//         "controller": [],
//         "updated_by": null,
//         "date_installation": "2022-04-14",
//         "condition": "Replacement <6M (Warranty No Change)",
//         "platform_fees": null,
//         "remark": null,
//         "datetime": "2022-10-18T14:24:19+08:00",
//         "serial": "AM1007"
//     },
//     {
//         "id": 7,
//         "product": "Agridose Hydroponics",
//         "pumpa": null,
//         "pumpb": null,
//         "pumpc": null,
//         "simcard": null,
//         "customer": "SFN",
//         "sensor": [
//             {
//                 "id": "28",
//                 "serial": "LECP21"
//             }
//         ],
//         "controller": [],
//         "updated_by": null,
//         "date_installation": "2022-06-28",
//         "condition": "Replacement >6M (Warranty Extended 6M)",
//         "platform_fees": null,
//         "remark": null,
//         "datetime": "2022-10-18T14:27:23+08:00",
//         "serial": "AM1007"
//     },
//     {
//         "id": 8,
//         "product": "Agridose Hydroponics",
//         "pumpa": null,
//         "pumpb": null,
//         "pumpc": null,
//         "simcard": null,
//         "customer": "Matang",
//         "sensor": [],
//         "controller": [],
//         "updated_by": null,
//         "date_installation": "2022-12-09",
//         "condition": "New Installation",
//         "platform_fees": null,
//         "remark": null,
//         "datetime": "2022-12-09T09:56:19+08:00",
//         "serial": "AF0001"
//     },
//     {
//         "id": 9,
//         "product": "Agridose Hydroponics",
//         "pumpa": "24E93883B",
//         "pumpb": "24E93895B",
//         "pumpc": "24E95105B",
//         "simcard": "896019200694401149",
//         "customer": "SFN",
//         "sensor": [],
//         "controller": [],
//         "updated_by": "aquametrics",
//         "date_installation": "2022-12-21",
//         "condition": "New Installation",
//         "platform_fees": "150",
//         "remark": null,
//         "datetime": "2022-12-10T14:07:48.027837+08:00",
//         "serial": "AM1008"
//     },
//     {
//         "id": 10,
//         "product": "Agridose Hydroponics",
//         "pumpa": "24E93883B",
//         "pumpb": "24E93895B",
//         "pumpc": "24E95105B",
//         "simcard": "896019200694401149",
//         "customer": "SFN",
//         "sensor": [],
//         "controller": [],
//         "updated_by": "aquametrics",
//         "date_installation": "2022-12-21",
//         "condition": "New Installation",
//         "platform_fees": "150",
//         "remark": null,
//         "datetime": "2022-12-10T14:30:14.852625+08:00",
//         "serial": "AM1008"
//     },
//     {
//         "id": 11,
//         "product": "Agridose Hydroponics",
//         "pumpa": "24E93883B",
//         "pumpb": "24E93895B",
//         "pumpc": "24E95105B",
//         "simcard": "896019200694401149",
//         "customer": "SFN",
//         "sensor": [],
//         "controller": [],
//         "updated_by": "aquametrics",
//         "date_installation": "2022-12-21",
//         "condition": "New Installation",
//         "platform_fees": "150",
//         "remark": null,
//         "datetime": "2022-12-10T15:08:42.961804+08:00",
//         "serial": "AM1008"
//     },
//     {
//         "id": 12,
//         "product": "Agridose Hydroponics",
//         "pumpa": "24E93883B",
//         "pumpb": "24E93895B",
//         "pumpc": "24E95105B",
//         "simcard": "896019200694401149",
//         "customer": "SFN",
//         "sensor": [],
//         "controller": [],
//         "updated_by": "aquametrics",
//         "date_installation": "2022-12-21",
//         "condition": "New Installation",
//         "platform_fees": "150",
//         "remark": null,
//         "datetime": "2022-12-10T15:10:18.421935+08:00",
//         "serial": "AM1008"
//     },
//     {
//         "id": 13,
//         "product": "Agridose Hydroponics",
//         "pumpa": "24E93883B",
//         "pumpb": "24E93895B",
//         "pumpc": "24E95105B",
//         "simcard": "896019200694401149",
//         "customer": "SFN",
//         "sensor": [],
//         "controller": [],
//         "updated_by": "aquametrics",
//         "date_installation": "2022-12-21",
//         "condition": "New Installation",
//         "platform_fees": "150",
//         "remark": null,
//         "datetime": "2022-12-10T15:12:30.858898+08:00",
//         "serial": "AM1008"
//     },
//     {
//         "id": 14,
//         "product": "Agridose Hydroponics",
//         "pumpa": "24E93883B",
//         "pumpb": "24E93895B",
//         "pumpc": "24E95105B",
//         "simcard": "896019200694401149",
//         "customer": "SFN",
//         "sensor": [],
//         "controller": [],
//         "updated_by": "aquametrics",
//         "date_installation": "2022-12-21",
//         "condition": "New Installation",
//         "platform_fees": "150",
//         "remark": null,
//         "datetime": "2022-12-10T15:14:02.038372+08:00",
//         "serial": "AM1008"
//     },
//     {
//         "id": 15,
//         "product": "Agridose Hydroponics",
//         "pumpa": "24E93883B",
//         "pumpb": "24E93895B",
//         "pumpc": "24E95105B",
//         "simcard": "896019200694401149",
//         "customer": "SFN",
//         "sensor": [],
//         "controller": [],
//         "updated_by": "aquametrics",
//         "date_installation": "2022-12-21",
//         "condition": "New Installation",
//         "platform_fees": "150",
//         "remark": null,
//         "datetime": "2022-12-10T15:15:07.572437+08:00",
//         "serial": "AM1008"
//     },
//     {
//         "id": 16,
//         "product": "Agridose Hydroponics",
//         "pumpa": "24E93883B",
//         "pumpb": "24E93895B",
//         "pumpc": "24E95105B",
//         "simcard": "896019200694401149",
//         "customer": "SFN",
//         "sensor": [
//             {
//                 "id": "7",
//                 "serial": "LPHT35"
//             },
//             {
//                 "id": "6",
//                 "serial": "LECP40"
//             }
//         ],
//         "controller": [],
//         "updated_by": "aquametrics",
//         "date_installation": "2022-12-21",
//         "condition": "New Installation",
//         "platform_fees": "150",
//         "remark": null,
//         "datetime": "2022-12-10T15:15:48.552171+08:00",
//         "serial": "AM1008"
//     },
//     {
//         "id": 17,
//         "product": "Agridose Hydroponics",
//         "pumpa": null,
//         "pumpb": "24E93895B",
//         "pumpc": "24E95105B",
//         "simcard": "896019200694401149",
//         "customer": "SFN",
//         "sensor": [
//             {
//                 "id": "7",
//                 "serial": "LPHT35"
//             },
//             {
//                 "id": "6",
//                 "serial": "LECP40"
//             }
//         ],
//         "controller": [],
//         "updated_by": "aquametrics",
//         "date_installation": "2022-12-21",
//         "condition": "New Installation",
//         "platform_fees": "150",
//         "remark": null,
//         "datetime": "2022-12-10T15:32:37.438024+08:00",
//         "serial": "AM1008"
//     },
//     {
//         "id": 18,
//         "product": "Agridose Hydroponics",
//         "pumpa": null,
//         "pumpb": "24E93895B",
//         "pumpc": "24E95105B",
//         "simcard": "896019200694401149",
//         "customer": "SFN",
//         "sensor": [],
//         "controller": [],
//         "updated_by": "aquametrics",
//         "date_installation": "2022-12-21",
//         "condition": "New Installation",
//         "platform_fees": "150",
//         "remark": null,
//         "datetime": "2022-12-10T15:42:33.768705+08:00",
//         "serial": "AM1008"
//     },
//     {
//         "id": 19,
//         "product": "Agridose Hydroponics",
//         "pumpa": null,
//         "pumpb": "24E93895B",
//         "pumpc": "24E95105B",
//         "simcard": "896019200694401149",
//         "customer": "SFN",
//         "sensor": [],
//         "controller": [],
//         "updated_by": "aquametrics",
//         "date_installation": "2022-12-21",
//         "condition": "New Installation",
//         "platform_fees": "150",
//         "remark": null,
//         "datetime": "2022-12-10T15:44:51.341443+08:00",
//         "serial": "AM1008"
//     },
//     {
//         "id": 20,
//         "product": "Agridose Hydroponics",
//         "pumpa": null,
//         "pumpb": "24E93895B",
//         "pumpc": "24E95105B",
//         "simcard": "896019200694401149",
//         "customer": "SFN",
//         "sensor": [],
//         "controller": [],
//         "updated_by": "aquametrics",
//         "date_installation": "2022-12-21",
//         "condition": "New Installation",
//         "platform_fees": "150",
//         "remark": null,
//         "datetime": "2022-12-10T18:23:08.175344+08:00",
//         "serial": "AM1008"
//     },
//     {
//         "id": 21,
//         "product": "Agridose Hydroponics",
//         "pumpa": null,
//         "pumpb": "24E93895B",
//         "pumpc": "24E95105B",
//         "simcard": "896019200694401149",
//         "customer": "SFN",
//         "sensor": [
//             {
//                 "id": "11",
//                 "serial": "LECP12"
//             }
//         ],
//         "controller": [],
//         "updated_by": "aquametrics",
//         "date_installation": "2022-12-21",
//         "condition": "New Installation",
//         "platform_fees": "150",
//         "remark": null,
//         "datetime": "2022-12-10T18:24:20.002940+08:00",
//         "serial": "AM1008"
//     },
//     {
//         "id": 22,
//         "product": "Agridose Hydroponics",
//         "pumpa": null,
//         "pumpb": "24E93895B",
//         "pumpc": "24E95105B",
//         "simcard": "896019200694401149",
//         "customer": "SFN",
//         "sensor": [
//             {
//                 "id": "11",
//                 "serial": "LECP12"
//             }
//         ],
//         "controller": [],
//         "updated_by": "aquametrics",
//         "date_installation": "2022-12-21",
//         "condition": "New Installation",
//         "platform_fees": "150",
//         "remark": null,
//         "datetime": "2022-12-10T18:25:17.761038+08:00",
//         "serial": "AM1008"
//     },
//     {
//         "id": 23,
//         "product": "Agridose Hydroponics",
//         "pumpa": null,
//         "pumpb": "24E93895B",
//         "pumpc": "24E95105B",
//         "simcard": "896019200694401149",
//         "customer": "SFN",
//         "sensor": [
//             {
//                 "id": "11",
//                 "serial": "LECP12"
//             }
//         ],
//         "controller": [],
//         "updated_by": "aquametrics",
//         "date_installation": "2022-12-21",
//         "condition": "New Installation",
//         "platform_fees": "150",
//         "remark": null,
//         "datetime": "2022-12-10T18:26:30.085066+08:00",
//         "serial": "AM1008"
//     },
//     {
//         "id": 24,
//         "product": "Agridose Hydroponics",
//         "pumpa": null,
//         "pumpb": "24E93895B",
//         "pumpc": "24E95105B",
//         "simcard": "896019200694401149",
//         "customer": "SFN",
//         "sensor": [
//             {
//                 "id": "11",
//                 "serial": "LECP12"
//             }
//         ],
//         "controller": [
//             {
//                 "id": "6",
//                 "board_name": "HaHa Davis Weather Station",
//                 "mcuid": "a46c70fa48a8"
//             }
//         ],
//         "updated_by": "aquametrics",
//         "date_installation": "2022-12-21",
//         "condition": "New Installation",
//         "platform_fees": "150",
//         "remark": null,
//         "datetime": "2022-12-10T18:27:04.433967+08:00",
//         "serial": "AM1008"
//     },
//     {
//         "id": 25,
//         "product": "Agridose Hydroponics",
//         "pumpa": null,
//         "pumpb": "24E93895B",
//         "pumpc": "24E95105B",
//         "simcard": "896019200694401149",
//         "customer": "SFN",
//         "sensor": [
//             {
//                 "id": "11",
//                 "serial": "LECP12"
//             }
//         ],
//         "controller": [
//             {
//                 "id": "6",
//                 "board_name": "HaHa Davis Weather Station",
//                 "mcuid": "a46c70fa48a8"
//             }
//         ],
//         "updated_by": "aquametrics",
//         "date_installation": "2022-12-21",
//         "condition": "New Installation",
//         "platform_fees": "150",
//         "remark": null,
//         "datetime": "2022-12-10T18:41:56.197898+08:00",
//         "serial": "AM1008"
//     },
//     {
//         "id": 26,
//         "product": "Agridose Hydroponics",
//         "pumpa": null,
//         "pumpb": "24E93895B",
//         "pumpc": "24E95105B",
//         "simcard": "896019200694401149",
//         "customer": "SFN",
//         "sensor": [],
//         "controller": [],
//         "updated_by": "aquametrics",
//         "date_installation": "2022-12-21",
//         "condition": "New Installation",
//         "platform_fees": "150",
//         "remark": null,
//         "datetime": "2022-12-10T19:09:11.132483+08:00",
//         "serial": "AM1009"
//     },
//     {
//         "id": 27,
//         "product": "Agridose Hydroponics",
//         "pumpa": null,
//         "pumpb": "24E93895B",
//         "pumpc": "24E95105B",
//         "simcard": "896019200694401149",
//         "customer": "SFN",
//         "sensor": [],
//         "controller": [],
//         "updated_by": "aquametrics",
//         "date_installation": "2022-12-21",
//         "condition": "New Installation",
//         "platform_fees": "150",
//         "remark": null,
//         "datetime": "2022-12-10T19:10:40.503943+08:00",
//         "serial": "AM1009"
//     },
//     {
//         "id": 28,
//         "product": "Agridose Hydroponics",
//         "pumpa": null,
//         "pumpb": "24E93895B",
//         "pumpc": "24E95105B",
//         "simcard": "896019200694401149",
//         "customer": "SFN",
//         "sensor": [],
//         "controller": [],
//         "updated_by": "aquametrics",
//         "date_installation": "2022-12-21",
//         "condition": "New Installation",
//         "platform_fees": "150",
//         "remark": null,
//         "datetime": "2022-12-10T19:11:22.927522+08:00",
//         "serial": "AM1009"
//     },
//     {
//         "id": 29,
//         "product": "Agridose Hydroponics",
//         "pumpa": null,
//         "pumpb": "24E93895B",
//         "pumpc": "24E95105B",
//         "simcard": "896019200694401149",
//         "customer": "SFN",
//         "sensor": [],
//         "controller": [],
//         "updated_by": "aquametrics",
//         "date_installation": "2022-12-21",
//         "condition": "New Installation",
//         "platform_fees": "150",
//         "remark": null,
//         "datetime": "2022-12-10T19:13:08.420491+08:00",
//         "serial": "AM1009"
//     },
//     {
//         "id": 30,
//         "product": "Agridose Hydroponics",
//         "pumpa": null,
//         "pumpb": "24E93895B",
//         "pumpc": "24E95105B",
//         "simcard": "896019200694401149",
//         "customer": "SFN",
//         "sensor": [],
//         "controller": [],
//         "updated_by": "aquametrics",
//         "date_installation": "2022-12-21",
//         "condition": "New Installation",
//         "platform_fees": "150",
//         "remark": null,
//         "datetime": "2022-12-10T19:14:56.413043+08:00",
//         "serial": "AM1009"
//     },
//     {
//         "id": 31,
//         "product": "Agridose Hydroponics",
//         "pumpa": null,
//         "pumpb": "24E93895B",
//         "pumpc": "24E95105B",
//         "simcard": "896019200694401149",
//         "customer": "SFN",
//         "sensor": [],
//         "controller": [],
//         "updated_by": "aquametrics",
//         "date_installation": "2022-12-21",
//         "condition": "New Installation",
//         "platform_fees": "150",
//         "remark": null,
//         "datetime": "2022-12-10T19:17:04.568717+08:00",
//         "serial": "AM1009"
//     },
//     {
//         "id": 32,
//         "product": "Agridose Hydroponics",
//         "pumpa": null,
//         "pumpb": "24E93895B",
//         "pumpc": "24E95105B",
//         "simcard": "896019200694401149",
//         "customer": "SFN",
//         "sensor": [
//             {
//                 "id": "11",
//                 "serial": "LECP12"
//             }
//         ],
//         "controller": [],
//         "updated_by": "aquametrics",
//         "date_installation": "2022-12-21",
//         "condition": "New Installation",
//         "platform_fees": "150",
//         "remark": null,
//         "datetime": "2022-12-10T19:19:57.937671+08:00",
//         "serial": "AM1009"
//     },
//     {
//         "id": 33,
//         "product": "Agridose Hydroponics",
//         "pumpa": null,
//         "pumpb": "24E93895B",
//         "pumpc": "24E95105B",
//         "simcard": "896019200694401149",
//         "customer": "Weng Seng",
//         "sensor": [],
//         "controller": [],
//         "updated_by": "bekzat",
//         "date_installation": "2022-12-21",
//         "condition": "New Installation",
//         "platform_fees": "2500",
//         "remark": null,
//         "datetime": "2022-12-10T21:48:09.040655+08:00",
//         "serial": "AM1010"
//     }
// ]
export default InstallationListV2